<template>
	<section class="sk-picker">
		<select class="sk-picker-field sk-picker-field-type" v-model="type" @change="onChange">
			<option v-for="item in collection" :key="item.key" :value="item.key">{{ item.name }}</option>
		</select>
		<picker-day @change="onChangeDate" v-if="isTypeDay" />
		<picker-month @change="onChangeDate" v-if="isTypeMonth" />
		<picker-year @change="onChangeDate" v-if="isTypeYear" />
	</section>
</template>

<script>
import moment from 'moment'
import PickerYear from './PickerYear'
import PickerMonth from './PickerMonth'
import PickerDay from './PickerDay'

export default {
	name: 'picker-calendar',
	components: {
		PickerYear,
		PickerMonth,
		PickerDay
	},
	data() {
		return {
			type: 'daily',
			datetime: {
				year: 0,
				month: 0,
				day: 0,
				hour: 0,
				minute: 0,
			},
			types: [
				{ active: true, key: 'daily', name: 'Daily' },
				{ active: false, key: 'weekly', name: 'Weekly' },
				{ active: true, key: 'monthly', name: 'Monthly' },
				{ active: true, key: 'yearly', name: 'Yearly' }
			]
		}
	},
	computed: {
		collection() {
			return this.types.filter(t => t.active === true)
		},
		isTypeDay() { return this.type === 'daily'},
		isTypeMonth() { return this.type === 'monthly'},
		isTypeYear() { return this.type === 'yearly'}
	},
	methods: {
		onChange() {
			// this.datetime = {
			// 	year: moment().year(),
			// 	month: moment().month() + 1,
			// 	day: moment().date(),
			// 	hour: 0,
			// 	minute: 0,
			// }
			// this.$emit('change', this.datetime, this.type)
		},
		onChangeDate(value) {
			this.datetime = value
			this.$emit('change', this.datetime, this.type)
		}
	}
}
</script>

<style>
.sk-picker {
	display: flex;
}
.sk-inner-picker {
	display: flex;
}
.sk-picker-field {
	border: 0;
	border-bottom: 1px solid var(--main-color-line-2);
	background-color: transparent;
	text-align: center;
	color: var(--main-font-color-invert-2);
}
.sk-picker-field-type {
	width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/modules/datetime/PickerCalendar.vue